import React, { useRef, useEffect, useState } from "react";
import styles from "./filter-sidebar.scss";
import { isFunction } from "lodash";
import { ConvertFilterSidebarToInsightsFilter } from "./filter-conversions";
import FilterSidebarLoader from "./loader";
import MbViewsManager from "../mb-views-manager/mb-views-manager";
import { analyticsFiltersApplied } from "../../containers/shared/analytics/actions";
import FilterCollection from "./filter-collection";

const FilterSidebar = (props) => {
  const sidebarRef = useRef(null);

  const {
    showSidebar,
    isLoading,
    insightsFiltersCollection,
    filterDefinitions,
    onUpdateFilters,
    onClearFilters,
    setSideBarVisibility = () => {
      console.log("setSideBarVisibility invoked");
    },
    shouldSetSideBarVisibilityOnClickOutside = true,
    lastAvailableDate,
    apiProvider,
    viewTypeData,
    hideViewManager = false,
    filterDefinitionsHaveLoaded,
    
    // 🔥 ADD THESE NEW PROPS
    fetchDynamicBrandsAndKeywords,  // Redux action from parent
    selectedDateRange,              // Current date range
  } = props;

  const [filtersCollection, setFiltersCollection] = useState([]);

  useEffect(() => {
    if (shouldSetSideBarVisibilityOnClickOutside) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  });

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      hideSidebar();
    }
  };

  const hideSidebar = () => {
    setSideBarVisibility(false);
  };

  const onClearFiltersCallback = () => {
    if (isFunction(onClearFilters)) {
      onClearFilters();
    }
  };

  // 🔥 REPLACE THIS ENTIRE FUNCTION
  const onFiltersChangeImmediate = async (updatedFiltersCollection) => {
    const filters = ConvertFilterSidebarToInsightsFilter(updatedFiltersCollection);
    
    // 🔥 CHECK IF RETAILER WAS CHANGED
    const retailerFilter = filters.find(f => 
      f.displayName === 'Retailer' || 
      f.mbName === 'rootdomain.keyword' ||
      f.mbName === 'rootdomain'
    );
    
    if (retailerFilter && retailerFilter.selectedValues?.length > 0) {
      // Get selected categories (if any)
      const categoryFilter = filters.find(f => 
        f.displayName === 'Category' || 
        f.mbName === 'category_path' ||
        f.mbName === 'mb_category'
      );
      const selectedCategories = categoryFilter?.selectedValues || [];
      
      // Convert enum (AmazonComAu) to domain (amazon.com.au) format
      let retailerDomain = retailerFilter.selectedValues[0];
      if (filterDefinitions) {
        const retailerFilterDef = filterDefinitions.find(
          fd => fd.displayName === 'Retailer' || fd.mbName === 'rootdomain.keyword'
        );
        if (retailerFilterDef?.enumDictionary) {
          retailerDomain = retailerFilterDef.enumDictionary[retailerDomain] || retailerDomain;
        }
      }
      
      // 🔥 CALL THE API DIRECTLY HERE (don't wait for Redux to propagate)
      if (fetchDynamicBrandsAndKeywords && apiProvider?.fetchDynamicFilterDefinitions) {
        try {
          const config = {
            // Add any custom config if needed
          };
          
          await fetchDynamicBrandsAndKeywords(
            apiProvider,
            retailerDomain,
            selectedCategories.length > 0 ? selectedCategories : null,
            selectedDateRange,
            config          
          );
        } catch (error) {
          console.error('[FilterSidebar] Failed to load dynamic filters:', error);
        }
      }
    }
    
    // Still update Redux as before
    if (isFunction(onUpdateFilters)) {
      onUpdateFilters(filters);
    }
  };

  const onUpdateFiltersCallback = () => {
    if (isFunction(onUpdateFilters)) {
      const filters = ConvertFilterSidebarToInsightsFilter(filtersCollection);
      onUpdateFilters(filters);
      analyticsFiltersApplied(viewTypeData.id, filtersCollection);
    }
  };

  return (
    <div
      className={styles.filterModal}
      style={{ display: showSidebar ? "block" : "none" }}
      ref={sidebarRef}
    >
      <div className={styles.modalHeader}>
        <i className={styles.chevronLeft} onClick={hideSidebar} />
      </div>
      {isLoading ? (
        <FilterSidebarLoader />
      ) : (
        <>
          {!hideViewManager && (
            <MbViewsManager
              lastAvailableDate={lastAvailableDate}
              apiProvider={apiProvider}
            />
          )}
          <FilterCollection
            filtersCollection={filtersCollection}
            setFiltersCollection={setFiltersCollection}
            onFiltersChangeImmediate={onFiltersChangeImmediate}
            insightsFiltersCollection={insightsFiltersCollection}
            filterDefinitions={filterDefinitions}
            filterDefinitionsHaveLoaded={filterDefinitionsHaveLoaded}
            height={hideViewManager ? 780 : 740}
            viewTypeId={viewTypeData?.id}
          />
          <div className={styles.modalFooter}>
            <div>
              <button
                className={[styles.btn, styles.btnClearFilter].join(" ")}
                onClick={onClearFiltersCallback}
              >
                Clear Filters
              </button>
            </div>
            <div>
              <button
                className={[styles.btn, styles.btnUpdateResults].join(" ")}
                onClick={onUpdateFiltersCallback}
              >
                Update Results
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FilterSidebar;
